@if (isModulesLoaded) {
  <div class="card">
    <div class="card-header card-header-squirrel">
      <!-- <h4>{{this.translate.data['ADDTENANTGROUPROLE'] | translate}}</h4>         -->
      @if (!isCreateFormCalled) {
        <h4>Zusatzmodule bearbeiten</h4>
      }
      @if (isCreateFormCalled) {
        <h4>Zusatzmodule hinzufügen</h4>
      }
    </div>
    <div class="card-body" >
      <mat-dialog-content>
        <form [formGroup]="modulesForm"  novalidate>
          <table mat-table [dataSource]="modules.controls" class="mat-elevation-z1">
            <!-- Modulname -->
            <div style="max-height: 400px; overflow-y: auto;">
              <ng-container matColumnDef="moduleName">
                <th mat-header-cell *matHeaderCellDef style="padding-right: 100px;">Modulname</th>
                <td mat-cell *matCellDef="let row" style="padding-right: 100px;">
                  {{ row.value.moduleName }}
                </td>
              </ng-container>
              <ng-container matColumnDef="isBooked">
                <th mat-header-cell *matHeaderCellDef style="padding-right: 100px;">Gebucht</th>
                <td mat-cell *matCellDef="let row" style="padding-right: 100px;">
                  <mat-checkbox [checked]="row.value.isBooked" [disabled]="row.value.isDisabled && !row.value.wasBooked" (change)="row.patchValue({ isBooked: $event.checked })"></mat-checkbox>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="['moduleName', 'isBooked']"></tr>
              <tr mat-row *matRowDef="let row; columns: ['moduleName', 'isBooked'];" [style.background-color]="row.value.isDisabled && !row.value.wasBooked ? '#f0f0f0' : 'transparent'"></tr>
              <!-- <tr mat-row *matRowDef="let row; columns: ['moduleName', 'isBooked'];" ></tr> -->
            </div>
          </table>
        </form>
      </mat-dialog-content>
      <div class="row">
        <a>
          <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
          (click)="cancel()" >Abbruch</button>
        </a>
        <span style="flex: 1 1 auto"></span>
        @if (!isCreateFormCalled) {
          <a>
            <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" matTooltip="Speichern der Modulbuchungen"
            (click)="add()" [disabled]="modulesForm.invalid">Speichern</button>
          </a>
        }
        @if (isCreateFormCalled) {
          <a>
            <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" matTooltip="Hinzufügen der Modulbuchungen"
            (click)="add()" [disabled]="modulesForm.invalid">Hinzufügen</button>
          </a>
        }
      </div>
    </div>
  </div>
}

